import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  ResponsiveContainer,
} from 'recharts'
import { Users } from 'lucide-react'
import { formatRand, formatRandCompact, type ManagerSlice } from '../../utils/performance'

function BreakdownTooltip({ active, payload }: any) {
  if (!active || !payload || payload.length === 0) return null
  const p = payload[0]
  return (
    <div className="rounded-md border border-border bg-popover px-3 py-2 text-xs shadow-md">
      <div className="font-medium text-popover-foreground">{p.payload.manager}</div>
      <div className="text-muted-foreground">
        Driver net:{' '}
        <span className="font-medium text-popover-foreground">{formatRand(p.value)}</span>
      </div>
    </div>
  )
}

export function ManagerBreakdown({
  data,
  loading,
}: {
  data: ManagerSlice[]
  loading: boolean
}) {
  const height = Math.max(160, data.length * 44 + 32)
  return (
    <div className="rounded-lg border border-border bg-card p-4 shadow-retool-sm">
      <div className="mb-1 flex items-center gap-2">
        <Users className="h-4 w-4 text-muted-foreground" />
        <h2 className="text-sm font-semibold text-foreground">Driver net by manager</h2>
      </div>
      <p className="mb-3 text-[11px] text-muted-foreground">
        Respects the date range; ignores the manager filter.
      </p>
      {loading ? (
        <div className="flex h-[200px] items-center justify-center text-sm text-muted-foreground">
          Loading…
        </div>
      ) : data.length === 0 ? (
        <div className="flex h-[200px] items-center justify-center text-sm text-muted-foreground">
          No data for the selected filters.
        </div>
      ) : (
        <ResponsiveContainer width="100%" height={height}>
          <BarChart
            data={data}
            layout="vertical"
            margin={{ top: 0, right: 16, bottom: 0, left: 8 }}
          >
            <CartesianGrid strokeDasharray="3 3" stroke="hsl(var(--border))" horizontal={false} />
            <XAxis
              type="number"
              tickFormatter={formatRandCompact}
              tick={{ fontSize: 11, fill: 'hsl(var(--muted-foreground))' }}
              tickLine={false}
              axisLine={{ stroke: 'hsl(var(--border))' }}
            />
            <YAxis
              type="category"
              dataKey="manager"
              width={120}
              tick={{ fontSize: 11, fill: 'hsl(var(--foreground))' }}
              tickLine={false}
              axisLine={false}
            />
            <Tooltip content={<BreakdownTooltip />} cursor={{ fill: 'hsl(var(--accent))', opacity: 0.4 }} />
            <Bar
              dataKey="driver_net"
              fill="hsl(var(--perf-driver-net))"
              radius={[0, 3, 3, 0]}
              maxBarSize={28}
            />
          </BarChart>
        </ResponsiveContainer>
      )}
    </div>
  )
}
